export type PricingProductKey = "standard" | "designer" | "api" | "education_student" | "education" | "designer_alumni";

export type PurchaseFlow = "card" | "business" | "customer-type";

export interface PricingProductDefinition {
    key: PricingProductKey;
    highlighted: boolean;
    hidden?: boolean;
    featureKeys: string[];
    contactOnly?: boolean;
    showTrial?: boolean;
    purchaseFlow?: PurchaseFlow;
    hideQuantity?: boolean;
}

export const energySystemsProductCatalog: PricingProductDefinition[] = [
    {
        key: "standard",
        highlighted: false,
        featureKeys: [
            "over1000Systems"
        ]
    },
    {
        key: "designer",
        highlighted: true,
        featureKeys: [
            "allStandardFeatures",
            "extended3DVisualization",
            "professionalReports"
        ]
    },
    {
        key: "api",
        highlighted: false,
        featureKeys: [
            "allDesignerFeatures",
            "restApiAccess",
            "automatedWorkflows"
        ],
        contactOnly: true
    }
];

export const educationProductCatalog: PricingProductDefinition[] = [
    {
        key: "education_student",
        highlighted: false,
        featureKeys: [
            "basicSimulation",
            "studentLicense"
        ],
        showTrial: false,
        purchaseFlow: "card",
        hideQuantity: true
    },
    {
        key: "designer_alumni",
        highlighted: false,
        hidden: true,
        featureKeys: [
            "allStandardFeatures",
            "extended3DVisualization",
            "professionalReports"
        ],
        showTrial: false,
        purchaseFlow: "card",
        hideQuantity: true
    },
    {
        key: "education",
        highlighted: true,
        featureKeys: [
            "allStudentFeatures",
            "advancedSimulation",
            "teachingMaterials"
        ],
        showTrial: false,
        purchaseFlow: "business",
        hideQuantity: true
    }
];

const pricingProductCatalog = {
    energySystemsProductCatalog,
    educationProductCatalog
};

export default pricingProductCatalog;



